import { createStore } from 'vuex';

import propertyItems from './modules/property-items';
import mapPoints from './modules/map-points';
import mapItem from './modules/map-item';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    propertyItems,
    mapPoints,
    mapItem
  }
});
